import _ from 'lodash';
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { serverUrl } from '../global/Environment';
import { logout } from '../actions/authActions';

const baseUrl = serverUrl();

export const TAGS = {
  EXPENSES: 'EXPENSES',
  FILES: 'FILES',
  NUM_BLUE_DOTS: 'NUM_BLUE_DOTS',
  TASKS: 'TASKS',
  TAX_PRO_CONSULTATION_AUTH: 'TAX_PRO_CONSULTATION_AUTH',
  TAX_PRO_CONSULTATION_MEETING_INFO: 'TAX_PRO_CONSULTATION_MEETING_INFO',
  TAX_PRO_CONSULTATION_TAX_PROS: 'TAX_PRO_CONSULTATION_TAX_PROS',
  TEST_ACCOUNT_FEATURES: 'TEST_ACCOUNT_FEATURES',
  UNNOTICED_USERS: 'UNNOTICED_USERS',
  USER_ACCOUNTS: 'USER_ACCOUNTS',
  USER_BOOKKEEPER_ASSIGNMENTS: 'USER_BOOKKEEPER_ASSIGNMENTS',
  USER_INFO: 'USER_INFO',
  USER_LIST: 'USER_LIST',
  USER_MESSAGES: 'USER_MESSAGES',
  USER_REMINDERS: 'USER_REMINDERS'
};

const QUERY_MAX_RETRIES = 3;

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}api/web-ops`,
  prepareHeaders: (headers) => {
    headers.set('Authorization', localStorage.getItem('KeeperToken'));
    // Headers to prevent return of cached data
    headers.set('Cache-Control', 'no-store');
    headers.set('Pragma', 'no-cache');
    headers.set('Expires', '0');
  },
  timeout: 10_000
});

const isUnauthorized = (response) => response?.data?.msg === 'Unauthorized Request';

export const baseQueryWithAuth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (isUnauthorized(result)) {
    await api.dispatch(logout());
  }

  return result;
};

const baseQueryWithRetry = retry(
  async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (isUnauthorized(result)) {
      api.dispatch(logout());
      retry.fail(result.error ?? { status: 'UNAUTHORIZED', data: result.data }, result.meta);
    }

    return result;
  },
  {
    maxRetries: QUERY_MAX_RETRIES
  }
);

const baseApi = createApi({
  refetchOnReconnect: true,
  refetchOnFocus: true,
  // Keep unused query data for 3 mins (this is how long cached query state is valid after removal of all subscriptions)
  keepUnusedDataFor: 3 * 60,
  baseQuery: baseQueryWithRetry,
  tagTypes: _.values(TAGS),
  endpoints: () => ({})
});

export default baseApi;
